import { RequestKind, boolean, string } from '@sb/library/base';
import { DisplayItemCollection, ReviewDisplayItem, ReviewInputItem, ReviewSearchOptions, ReviewStatusUpdateItem, ReviewSummaryDisplayItem, ReviewUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export const ReviewRoutes = {
    Add: ApiRoute.Define({
        URL: `review`,
        Kind: RequestKind.Post,
        BodyType: ReviewInputItem,
        ResultType: string,
    }),
    Update: ApiRoute.Define({
        URL: (reviewID: string) => `review/${reviewID}`,
        Kind: RequestKind.Put,
        BodyType: ReviewUpdateItem,
    }),
    Delete: ApiRoute.Define({
        URL: (id: string) => `review/${id}`,
        Kind: RequestKind.Delete,
        ResultType: boolean,
    }),
    Get: ApiRoute.Define({
        URL: (id: string) => `review/${id}`,
        Kind: RequestKind.Get,
        ResultType: ReviewDisplayItem,
    }),
    Search: ApiRoute.Define({
        URL: `search/review`,
        Kind: RequestKind.Post,
        PagingAllowed: true,
        BodyType: ReviewSearchOptions,
        ResultType: DisplayItemCollection<ReviewDisplayItem>,
    }),
    UpdateStatus: ApiRoute.Define({
        URL: (reviewID: string) => `review/status/${reviewID}`,
        Kind: RequestKind.Put,
        BodyType: ReviewStatusUpdateItem,
    }),

    Summary: {
        Get: ApiRoute.Define({
            URL: (schoolID: string, teacherID: string) => `review/summary/${schoolID}/${teacherID}`,
            Kind: RequestKind.Get,
            ResultType: ReviewSummaryDisplayItem,
        }),
        GetAll: ApiRoute.Define({
            URL: (schoolID: string) => `review/summary/${schoolID}`,
            Kind: RequestKind.Get,
            ResultType: Array<ReviewSummaryDisplayItem>,
        }),
    },
};
